import React from "react"
import ReactDOM from "react-dom"
import "styles/globals.css"
import "mapbox-gl/dist/mapbox-gl.css"
import "mapbox-gl-controls/lib/controls.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"

import { init as initFullStory } from "@fullstory/browser"

initFullStory({ orgId: process.env.REACT_APP_FULLSTORY_ORG_ID })

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
